import * as Sentry from "@sentry/react";
import { useRouter } from "next/router";
import { useEffect } from "react";
/**
 * checkout 페이지의 라우터 파라미터 해석
 *
 * router.query는 `string | string[] | undefined`라 쓰는 곳마다 캐스팅이 필요했다.
 * 캐스팅을 이 훅 안에 가두고, 밖에서는 타입이 붙은 값과 파생 플래그만 쓴다.
 */ export const useCheckoutParams = ()=>{
    const router = useRouter();
    const { id , orderType  } = router.query;
    // 월구독은 토스 결제위젯이 아니라 빌링키 등록 경로를 탄다.
    const isSubscription = orderType === "subscription";
    // TODO(월구독): 키가 없으면 위젯 결제로 폴백하는데, 폴백할 원래 주문이 없어 구독 상품 위에
    // 일반 결제 UI가 얹힌 화면이 된다. (`?billing=true` 시절에는 부가 플래그라 폴백이 성립했다)
    // 위젯을 쓰면 안 되는 상태이므로 다이얼로그·에러 화면으로 막아야 한다. 프로덕션 키 주입 후 처리한다.
    const isBilling = isSubscription && !!process.env.NEXT_PUBLIC_TOSS_BILLING_CLIENT_KEY;
    /**
   * 키가 없어 일반 결제로 빠지는 상태를 알린다.
   *
   * 이때 화면은 월구독 주문에 일반 결제 UI가 얹힌 상태가 된다 — 진입 가드가 꺼지고(enabled: isBilling)
   * 토스 위젯이 마운트되며 캐시·포인트 카드까지 노출된다. 화면상 구분이 안 되고 유저 콘솔은 볼 수 없으므로
   * Sentry로 보고한다. 배포 순서(키 주입 → BE 상품 활성화)가 어긋났다는 신호다.
   */ useEffect(()=>{
        if (!isSubscription || isBilling) return;
        ;
        Sentry.captureMessage("[월구독] 빌링 clientKey 누락 — 일반 결제 경로로 진행", {
            level: "warning",
            tags: {
                feature: "monthly-billing",
                phase: "config"
            },
            fingerprint: [
                "monthly-billing-missing-client-key"
            ]
        });
    }, [
        isSubscription,
        isBilling
    ]);
    return {
        id: id,
        orderType: orderType,
        /** 월구독 빌링 UI 노출 여부 */ isBilling,
        /** 이용권·패키지 계열 주문 (결제 실패 메시지 노출 조건) */ isMembership: orderType === "pass" || orderType === "package" || orderType === "upgrade",
        /** 주문자 정보 폼 사용 여부 - pod, delivery 주문 시 사용 */ shouldUseForm: orderType === "pod" || orderType === "delivery",
        /** 배송 주문 여부 (주문자 정보·배송지 섹션 노출 조건) */ isDeliveryOrder: orderType === "delivery" || orderType === "pod"
    };
};
